import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { viewPayoutAction } from '../../actions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

function PayoutView({ payout }) {
    return (
        <div className="col-lg-12">
            <div className="card">
                {
                    payout ?
                        <>
                            <div className="header d-flex justify-content-between align-items-center">
                                <h2>
                                    Payout ID :{payout._id}
                                </h2>
                            </div>
                            <div className="body table-responsive">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>First Name:</th>
                                            <td>{payout.userId.firstName}</td>

                                        </tr>
                                        <tr>
                                            <th>Last Name:</th>
                                            <td>{payout.userId.lastName}</td>
                                        </tr>
                    
                                        <tr>
                                            <th>Amount:</th>
                                            <td>{'£' + payout.amount}</td>
                                        </tr>
                                
                                        <tr>
                                            <th>Created At:</th>
                                            <td>{moment(payout.createdAt).format('YYYY-MM-DD hh:mm a')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </> :
                        <div className="text-center mt-2">
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                timeout={3000} //3 secs
                            />
                        </div>
                }

            </div>
        </div>
    )
}

export default connect(null, { viewPayoutAction })(PayoutView)